var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillDiveWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 22,
    viewBox: "0 0 108 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8778_144398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5857 1.61804V18.4269C73.5857 19.2206 73.6206 20.0067 73.689 20.7826H69.9086C69.8389 20.359 69.8053 19.9355 69.8053 19.5119C69.4942 19.9711 69.0326 20.3451 68.4203 20.6363C67.8069 20.9276 67.1212 21.0726 66.3609 21.0726C64.5304 21.0726 63.0111 20.4239 61.8028 19.1265C60.5945 17.8291 59.9897 16.1756 59.9897 14.1633C59.9897 12.1511 60.5771 10.5497 61.7505 9.2536C62.924 7.9562 64.4172 7.3075 66.2303 7.3075C68.0433 7.3075 69.1471 7.75778 69.7008 8.65705V1.61804H73.5857ZM64.7943 11.7822C64.233 12.347 63.9531 13.1496 63.9531 14.1913C63.9531 15.2331 64.233 16.0408 64.7943 16.6131C65.3555 17.1868 66.0411 17.473 66.8524 17.473C67.6638 17.473 68.3507 17.1868 68.9119 16.6131C69.4731 16.0395 69.7531 15.2331 69.7531 14.1913C69.7531 13.1496 69.4718 12.347 68.9119 11.7822C68.3507 11.2175 67.6638 10.9351 66.8524 10.9351C66.0411 10.9351 65.3542 11.2175 64.7943 11.7822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5635 5.27112C76.1143 4.81195 75.8903 4.2561 75.8903 3.60359C75.8903 2.95107 76.1143 2.39523 76.5635 1.93605C77.0127 1.47688 77.5478 1.24792 78.1688 1.24792C78.7897 1.24792 79.3559 1.47688 79.8126 1.93605C80.2693 2.39523 80.4995 2.95107 80.4995 3.60359C80.4995 4.2561 80.2705 4.81322 79.8126 5.27112C79.3546 5.7303 78.8071 5.95925 78.1688 5.95925C77.5304 5.95925 77.0115 5.7303 76.5635 5.27112ZM80.1635 20.7826H76.2275V7.62679H80.1635V20.7826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3634 7.62683L90.4693 20.7827H86.5073L81.2249 7.62683H85.4981L88.4759 15.8055L91.2209 7.62683H95.3647H95.3634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.478 16.0434L107.767 16.9961C107.439 18.2133 106.757 19.2156 105.722 20.0004C104.686 20.7852 103.391 21.1783 101.837 21.1783C99.9726 21.1783 98.3885 20.5435 97.0844 19.2729C95.7803 18.0022 95.1295 16.299 95.1295 14.1647C95.1295 12.0303 95.7642 10.4506 97.0334 9.16208C98.3027 7.87359 99.8083 7.22998 101.552 7.22998C103.554 7.22998 105.129 7.82526 106.278 9.01708C107.425 10.2076 108 11.8624 108 13.9803C108 14.6506 107.974 15.0652 107.923 15.2242H98.9634C98.9983 15.948 99.3006 16.5521 99.8693 17.038C100.439 17.5239 101.112 17.7656 101.889 17.7656C103.218 17.7656 104.082 17.1919 104.478 16.0446V16.0434ZM99.0406 12.6282H104.194C104.159 12.0278 103.93 11.5076 103.507 11.0662C103.084 10.6248 102.449 10.4048 101.603 10.4048C100.842 10.4048 100.239 10.6337 99.7897 11.0929C99.3405 11.5521 99.0903 12.0634 99.0381 12.6282H99.0406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2461 17.5226L25.4635 16.7289C25.5506 17.417 25.8455 17.9907 26.3508 18.4499C26.8547 18.8912 27.5329 19.1113 28.3853 19.1113C29.0461 19.1113 29.5674 18.9523 29.9507 18.6343C30.3327 18.2985 30.5244 17.8927 30.5244 17.417C30.5244 16.5699 29.9856 16.023 28.9067 15.7762L26.7676 15.2992C25.7933 15.0881 25.0292 14.6633 24.4718 14.0285C23.9155 13.3926 23.6368 12.6256 23.6368 11.725C23.6368 10.6311 24.0711 9.68609 24.9409 8.89239C25.8281 8.09868 26.8796 7.70056 28.0966 7.70056C28.8967 7.70056 29.6098 7.82394 30.2357 8.0707C30.8616 8.29965 31.3481 8.60874 31.6966 8.99669C32.0437 9.38463 32.3051 9.74714 32.4793 10.0817C32.6535 10.4175 32.7841 10.7609 32.87 11.1145L30.7048 11.9349C30.67 11.7238 30.609 11.5202 30.5219 11.3256C30.4348 11.1132 30.2954 10.8843 30.105 10.6375C29.9308 10.3907 29.6707 10.1961 29.3223 10.055C28.9751 9.89596 28.5657 9.8171 28.0966 9.8171C27.4881 9.8171 26.9841 9.98499 26.5835 10.3195C26.2014 10.6553 26.0098 11.0522 26.0098 11.5113C26.0098 12.3229 26.4876 12.8354 27.4446 13.0466L29.4791 13.4969C30.5916 13.7436 31.444 14.2028 32.035 14.8731C32.6435 15.5256 32.9484 16.3295 32.9484 17.2822C32.9484 18.2883 32.5402 19.1978 31.7227 20.0093C30.9226 20.8208 29.8014 21.2265 28.3579 21.2265C26.8099 21.2265 25.6016 20.8386 24.7318 20.0614C23.862 19.2677 23.3668 18.4206 23.2448 17.5201L23.2461 17.5226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3684 8.09872L40.0214 13.4727L45.473 20.8323H42.3956L38.3004 15.2191L36.5533 16.9935V20.8323H34.1281V1.66516H36.5533V13.7373L41.9788 8.09872H45.3697H45.3684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1695 20.8323H45.7442V8.0987H48.1695V20.8323ZM45.692 4.55122C45.361 4.19761 45.1967 3.77405 45.1967 3.28053C45.1967 2.78701 45.3622 2.36218 45.692 2.00985C46.0392 1.65624 46.4573 1.48071 46.9438 1.48071C47.4304 1.48071 47.8485 1.65751 48.1956 2.00985C48.5428 2.34564 48.717 2.7692 48.717 3.28053C48.717 3.79186 48.5428 4.19888 48.1956 4.55122C47.8485 4.88701 47.4304 5.05364 46.9438 5.05364C46.4573 5.05364 46.0392 4.88574 45.692 4.55122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7065 20.8323H50.2551V1.66516H52.7065V20.8323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2422 20.8323H54.7908V1.66516H57.2422V20.8323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3989 6.73386L18.1093 8.19025L17.0877 8.84276L14.798 10.3017L13.7764 10.9529L10.2001 13.231L6.63 10.9555H6.62875L5.60961 10.3055L3.31375 8.84403L2.29337 8.19534L0 6.73386L10.2088 0.5L20.3989 6.73386Z",
    fill: "url(#paint0_linear_8778_144398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3989 15.0029L10.2001 21.5L0 15.0029L2.28342 13.6075L10.2001 18.6521L18.1193 13.6075L20.3989 15.0029Z",
    fill: "url(#paint1_linear_8778_144398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3989 10.8537L18.1093 12.2974L17.0877 12.941L10.2001 17.2834L3.31375 12.9423L2.29337 12.2999L0 10.8537L2.28217 9.4749H2.28342L4.57679 10.9224L5.59717 11.5647L10.2001 14.4673L14.8092 11.5622L15.8296 10.9173L18.1193 9.47363L20.3989 10.8537Z",
    fill: "url(#paint2_linear_8778_144398)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8778_144398",
    x1: 0,
    y1: 6.86487,
    x2: 20.3989,
    y2: 6.86487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A23AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#813AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6037E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8778_144398",
    x1: 0,
    y1: 17.5544,
    x2: 20.3989,
    y2: 17.5544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51E0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8778_144398",
    x1: 0,
    y1: 13.3785,
    x2: 20.3989,
    y2: 13.3785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4365AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558BDC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8778_144398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 21,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillDiveWhite);
export default __webpack_public_path__ + "static/media/skill_dive_white.a9bc393b6f876f44e5e2de8489cdc2f6.svg";
export { ForwardRef as ReactComponent };